import { render, staticRenderFns } from "./Comunity.vue?vue&type=template&id=d0a9122a&scoped=true&"
import script from "./Comunity.vue?vue&type=script&lang=js&"
export * from "./Comunity.vue?vue&type=script&lang=js&"
import style0 from "./Comunity.vue?vue&type=style&index=0&id=d0a9122a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a9122a",
  null
  
)

export default component.exports